import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Configuration } from '../../models/logged-in-user';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigManagementService {
  constructor(private http: ApiClient) {}

  saveConfig(config: Configuration): Observable<Configuration> {
    return this.http.post<Configuration>('config', config);
  }
}
